module.exports = __webpack_public_path__ + "static/img/logo85.a6c29fe.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo85.png
// module id = fcqA
// module chunks = 1